import { render } from "./Sources.vue?vue&type=template&id=623b0044&scoped=true"
import script from "./Sources.vue?vue&type=script&lang=js"
export * from "./Sources.vue?vue&type=script&lang=js"

import "./Sources.vue?vue&type=style&index=0&id=623b0044&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623b0044"]])

export default __exports__